import { r as registerInstance, h } from './index-2b2e631a.js';

let SearchTopHitBase = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  /**
   * Render element
   */
  render() {
    return (h("slot", null));
  }
};

export { SearchTopHitBase as search_top_hit_base };
